let routes = [
    // 苯乙烯
    {
        path: 'styrene',
        name: '苯乙烯',
        component: () => import('@/views/styrene/index'),
    },
    {
        path: 'styrene/twoPage/industry',
        name: '苯乙烯行业动态二级页',
        component: () => import('@/views/styrene/twoPage/industry')
    },
    {
        path: 'styrene/industry',
        name: '苯乙烯行业动态详情页',
        component: () => import('@/views/styrene/detail/industry')
    },
    {
        path: 'styrene/twoPage/yield',
        name: '苯乙烯产量二级页',
        component: () => import('@/views/styrene/twoPage/yield')
    },
    {
        path: 'styrene/yield',
        name: '苯乙烯产量详情页',
        component: () => import('@/views/styrene/detail/yield')
    },
    {
        path: 'styrene/twoPage/exit',
        name: '苯乙烯进出口二级页',
        component: () => import('@/views/styrene/twoPage/exit')
    },
    {
        path: 'styrene/exit',
        name: '苯乙烯进出口详情页',
        component: () => import('@/views/styrene/detail/exit')
    },
    {
        path: 'styrene/twoPage/stock',
        name: '苯乙烯库存二级页',
        component: () => import('@/views/styrene/twoPage/stock')
    },
    {
        path: 'styrene/stock',
        name: '苯乙烯库存详情页',
        component: () => import('@/views/styrene/detail/stock')
    },
    {
        path: 'styrene/twoPage/price',
        name: '苯乙烯价格二级页',
        component: () => import('@/views/styrene/twoPage/price')
    },
    {
        path: 'styrene/price',
        name: '苯乙烯价格详情页',
        component: () => import('@/views/styrene/detail/price')
    },
    {
        path: 'styrene/twoPage/profit',
        name: '苯乙烯利润二级页',
        component: () => import('@/views/styrene/twoPage/profit')
    },
    {
        path: 'styrene/profit',
        name: '苯乙烯后利润详情页',
        component: () => import('@/views/styrene/detail/profit')
    },
    {
        path: 'styrene/twoPage/device',
        name: '苯乙烯装置动态二级页',
        component: () => import('@/views/styrene/twoPage/device')
    },
    {
        path: 'styrene/device',
        name: '苯乙烯后装置动态详情页',
        component: () => import('@/views/styrene/detail/device')
    },
    {
        path: 'styrene/twoPage/rate',
        name: '苯乙烯开工率二级页',
        component: () => import('@/views/styrene/twoPage/rate')
    },
    {
        path: 'styrene/rate',
        name: '苯乙烯后开工率详情页',
        component: () => import('@/views/styrene/detail/rate')
    },
    {
        path: 'styrene/twoPage/plastics',
        name: '苯乙烯塑料二级页',
        component: () => import('@/views/styrene/twoPage/plastics')
    },
    {
        path: 'styrene/stringProfit',
        name: '苯乙烯后塑料字符串详情页',
        component: () => import('@/views/styrene/detail/stringProfit')
    },
    {
        path: 'styrene/numberProfit',
        name: '苯乙烯后塑料数值详情页',
        component: () => import('@/views/styrene/detail/numberProfit')
    },
    {
        path: 'styrene/twoPage/report',
        name: '苯乙烯研究报告二级页',
        component: () => import('@/views/styrene/twoPage/report')
    },
    {
        path: 'styrene/twoPage/standard',
        name: '苯乙烯技术及标准二级页',
        component: () => import('@/views/styrene/twoPage/standard')
    },
    {
        path: 'styrene/map',
        name: '苯乙烯地图',
        component: () => import('@/views/styrene/detail/map.vue')
    },
]

export default routes;
